import React from 'react';
import { Switch } from 'react-router-dom';

import { Routes } from '../assets/constants/routes';
import { RoutesConfig } from '../config/routes.config';

const App: React.FC = () => {
  return (
    <div
      className='app-wrapper d-flex flex-column justify-content-between'
      id='LiliApp-container'
    >
      <Switch>{RoutesConfig(Routes)}</Switch>
    </div>
  );
};

export default App;
